var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"http://freesaasofficedata.oss.aliyuncs.com/miShop/20210902154400546.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }